import { CARELON_PROVIDER_DIRECTORY_FEATURE_FLAGS } from './constants'

import type { CarelonProviderDirectoryFeatureFlagValues } from './types'
import type { LDFlags } from '../flags/useFlags'

/** Maps LaunchDarkly flags to the names used in Carelon rules. Missing flags default to false. */
export const getCarelonProviderDirectoryFeatureFlags = ({
  isCarelonOutpatientTherapyEnabled,
}: Readonly<Partial<LDFlags>>): CarelonProviderDirectoryFeatureFlagValues => ({
  [CARELON_PROVIDER_DIRECTORY_FEATURE_FLAGS.OUTPATIENT_THERAPY]: isCarelonOutpatientTherapyEnabled === true,
})
